const { Splide } = require("@splidejs/splide");

const pageCms = {
    init() {
        
        
        
    },
};

module.exports = pageCms;
